import { Paper, styled, PaperProps } from "@mui/material";
import React from "react";
import { breakpointValues, customBreakpoints } from "../../../styles/breakpoints";
import { pxToRem } from "../../../utils/fontSizeUtility";

export const ChatHistoryPaper = styled(Paper)<PaperProps>(({ theme }) => ({
  height: "100%",
  msOverflowStyle: "none",
  overflowY: "auto",
  "::-webkit-scrollbar": {
    display: "none",
  },
  scrollbarWidth: "none",
  paddingTop: pxToRem(30),
  [customBreakpoints.up(breakpointValues.md)]: {
    paddingTop: pxToRem(60),
  },
  [customBreakpoints.up(breakpointValues.lg)]: {
    paddingTop: pxToRem(100),
  },
})) as React.ComponentType<PaperProps>;
